export default {
  menuTitle: 'Dashboard',
  pageTitle: 'Affiliate Dashboard',
  businessTimezone: 'Business timezone: {timezone}',
  generatedAt: 'Updated: {time}',
  refresh: 'Refresh data',
  period: 'Period',
  periodToday: 'Today',
  periodMonth: 'Month to date',
  periodAll: 'All time',
  coreMetrics: 'Core Metrics',
  shareCount: 'Product Shares',
  orders: 'Commission Orders',
  actualSales: 'Actual Sales',
  commissionSpend: 'Commission Spend',
  previousDay: 'Yesterday',
  previousMonth: 'Previous month to date',
  previousPeriodValue: '{period}: {value}',
  trend: 'Last 30 Days',
  metricGmv: 'Sales',
  metricCommission: 'Commission',
  metricShares: 'Shares',
  metricClicks: 'Clicks',
  metricOrders: 'Orders',
  metricCount: 'Count',
  trendPendingExternal: 'Some daily {metrics} data is pending and is not shown as zero.',
  funnel: 'Conversion Funnel (This Month)',
  funnelExposure: 'Affiliate Product Impressions',
  funnelClicks: 'Product Detail Clicks',
  funnelShares: 'Shares',
  funnelOrders: 'Orders',
  funnelSigned: 'Signed',
  rankings: 'Top 5 Commission Products (All Time)',
  ranking: 'Rank',
  product: 'Product',
  cpsSalesQuantity: 'Affiliate Sales',
  commissionRate: 'Commission Rate',
  commission: 'Total Commission',
  gmv: 'Total Sales',
  unavailableProduct: 'Product information unavailable',
  listingId: 'Listing ID: {id}',
  pendingExternal: 'Data pending',
  partialInternal: 'Some data is unavailable',
  rankingPartial: '{count} incomplete records are excluded; the ranking shows currently provable data.',
  noData: 'No data',
  loadFailed: 'Failed to load the Affiliate dashboard',
  unknownError: 'Request failed. Please try again later.'
}
